import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { IconButtonComponent } from '@ird/ng-base';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'shared-export-csv-smackbar',
  templateUrl: './export-csv-snackbar.component.html',
  styleUrls: ['./export-csv-snackbar.component.scss'],
  imports: [IconButtonComponent, TranslatePipe],
})
export class ExportCSVSnackbarComponent {
  constructor(private snackBar: MatSnackBar) {}

  cancelSnackbar(): void {
    this.snackBar.dismiss();
  }
}
